import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    set_ip_details,
    set_data_reset, set_entities, set_entities_reset,
    set_tabnames, set_tabnames_reset, set_hostname
} from '../../../redux/actions/appActions'
import InfoComponent from '../InfoComponent';
import IpGeo from '../IpGeo';
import { useRouter } from "next/router";
import validator from 'validator';
import { loadData } from '../loadData'

export default function GeoIpFinder({ setIsLoading,
    infoMessage,
    setInfoMessage,
    placeHolder,
    buttonSearch,
    buttonClear,
    placeHolderDetail,
    info }) {

    const router = useRouter();
    let language = router.locale === "tr" ? "Turkish" : "English";

    const stateData = useSelector(state => state.app);
    const { ip } = stateData;
    const dispatch = useDispatch();
    const [ipComp, setIpComp] = useState("");

    const [splitIpOne, setSplitIpOne] = useState('');
    const [splitIpTwo, setSplitIpTwo] = useState('');
    const [splitIpThree, setSplitIpThree] = useState('')
    const [isSubmitPress, seIsSubmitPress] = useState(false)

    const [isValid, setIsValid] = useState(false);
    const [error, setError] = useState();

    useEffect(()=>{
        setIpComp(ip)
    },[ip]
    )


    useEffect(() => {

        let isValid = true;
        let ipValid = false;
        let ipValidTwo = true;
        let numberRegex = /^[0-9]+$/;
        let numb = numberRegex.test(ipComp);

        let splitArrayIp = ipComp.split(', ');

        if (splitArrayIp.length < 2) {
            splitArrayIp = ipComp.split(',')
        }
        if (splitArrayIp.length < 2) {
            splitArrayIp = ipComp.split(' ')
        }
        if (splitArrayIp.length < 2) {
            splitArrayIp = ipComp.split("\n")
        }
        const ip1 = splitArrayIp[0].trim();
        let ip2;
        let ip3;

        /// second input check
        if (splitArrayIp.length > 1) {
            ip2 = splitArrayIp[1].trim();
            setSplitIpTwo(ip2);
            ipValidTwo = false;
            if (numb) ipValidTwo = validator.isIP(ip2, [4]);
            else ipValidTwo = validator.isURL(ip2, [{ require_protocol: false }])
        }
        /// third input check
        if (splitArrayIp.length > 2) {
            ip3 = splitArrayIp[2].trim();
            setSplitIpThree(ip3);
            ipValidThree = false;
            if (numb) ipValidThree = validator.isIP(ip3, [4]);
            else ipValidThree = validator.isURL(ip3, [{ require_protocol: false }])
        }

        setSplitIpOne(ip1);
        if (numb) ipValid = validator.isIP(ip1, [4]);
        else ipValid = validator.isURL(ip1, [{ require_protocol: false }])

        if ((!ipValid && ip1.length > 0) || (!ipValidTwo && ip2.length > 0)) {
            isValid = false;
            setError(router.locale === "tr" ? "Lutfen IP veya Hostname'i dogru giriniz." : "Please enter correct IP or Hostname");
        }
        if (ipComp.trim().length === 0) {
            isValid = false;
            setError(router.locale === "tr" ? "Bu alan boş bırakılamaz." : "This field cannot be left blank");
        }
        if (isValid) setError("")
        setIsValid(isValid)
    }, [ipComp, router.locale])

    // submit handler
    const onSubmitHandler = async (event) => {
        event.preventDefault();
        seIsSubmitPress(true)
        /// max three value accepted
        if (isValid) await loadData(splitIpOne,
            'iplocation/p1',
            "mm",
            setIsLoading,
            setInfoMessage,
            dispatch,
            set_entities,
            set_ip_details,
            set_tabnames,
            language,
            set_hostname);
        if (splitIpTwo !== '' && isValid) {
            await loadData(splitIpTwo, 
                'iplocation/p1', 
                "mm", 
                setIsLoading,
                setInfoMessage, 
                dispatch, 
                set_entities, 
                set_ip_details, 
                set_tabnames, 
                language, 
                set_hostname);
        }
        if (splitIpThree !== '' && isValid) {
            await loadData(splitIpThree, 
                'iplocation/p1', 
                "mm", 
                setIsLoading, 
                setInfoMessage, 
                dispatch, 
                set_entities, 
                set_ip_details, 
                set_tabnames, 
                language, 
                set_hostname);
        }
        if (isValid) seIsSubmitPress(false)
    }

    // clears redux data and input values
    const clearHandle = () => {
        dispatch(set_data_reset());
        dispatch(set_entities_reset());
        dispatch(set_tabnames_reset());
        setInfoMessage('');
        setIpComp('');
        setSplitIpOne('');
        setSplitIpTwo('')
        setSplitIpThree('')
    }

    return (
        <>
            <InfoComponent info={info} />
            <IpGeo
                value={ipComp}
                placeHolder={placeHolder}
                error={error}
                isValid={isValid}
                buttonSearch={buttonSearch}
                buttonClear={buttonClear}
                onSubmitHandler={onSubmitHandler}
                clearHandle={clearHandle}
                placeHolderDetail={placeHolderDetail}
                message={infoMessage}
                pressed={isSubmitPress}
                setIpComp={setIpComp}
            />
        </>
    )
}


